import React from 'react';

class Input extends React.Component{    

    render(){

        let field = null;
        let fieldLabel = null;

        if(this.props.field.required === true){
            fieldLabel = this.props.field.label + " *";
        }
        else{
            fieldLabel = this.props.field.label;
        }

        if(this.props.field.type === "text" || this.props.field.type === "email"){
           
            if(this.props.field.required){
                field =  <div className="form-group"> 
                <input className={this.props.fieldStatus ? "form-control" : "form-control  is-invalid"} 
                type={this.props.field.type} 
                name={this.props.field.name} 
                value={this.props.value} 
                placeholder={fieldLabel}  
                onChange={this.props.handleInputChange}  />
                {this.props.fieldStatus === true ? "" : <div style={{color: this.props.checkTheme ? "white" : ""}} className="invalid-feedback">{this.props.field.errormsg}</div>}</div>
            }else{
                field =  <div className="form-group">
                <input className={this.props.fieldStatus ? "form-control" : "form-control"} 
                type={this.props.field.type} 
                name={this.props.field.name} 
                value={this.props.value} 
                placeholder={fieldLabel} 
                onChange={this.props.handleInputChange} />
                {this.props.fieldStatus === true ? "" : <div className="invalid-feedback" style={{color: this.props.checkTheme ? "white" : ""}}>{this.props.field.errormsg}</div>}</div>
            }        
        }
    
        if(this.props.field.type === "textarea"){
            if(this.props.field){
                field =  <div className="form-group">
                <textarea className={this.props.fieldStatus ? "form-control" : "form-control"} 
                name={this.props.field.name} 
                placeholder={fieldLabel}  
                value =  {this.props.value}
                 onChange={this.props.handleInputChange}/>

              {this.props.fieldStatus ? "" : <div className="invalid-feedback" style={{color: this.props.checkTheme ? "white" : ""}}>{this.props.field.errormsg}</div>}
                </div>
            }else{

                field =  <div className="form-group">
                <textarea className={this.props.fieldStatus ? "form-control" : "form-control"} 
                name={this.props.field.name} 
                placeholder={fieldLabel}  
                value =  {this.props.value}
                 onChange={this.props.handleInputChange}  />
                 {this.props.fieldStatus ? "" : <div className="invalid-feedback" style={{color: this.props.checkTheme ? "white" : ""}}>{this.props.field.errormsg}</div>}
                </div>
            }        
        }
        return field;
    }

}

export default Input;


// WEBPACK FOOTER //
// ./src/components/Input.js